import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface withDrawRequest extends BaseRequest {
  invId: string; //邀请活动ID
  cash: string; //提现金额，可以带小数 ,
}

export interface ApiNullVO {}

interface withDrawResponse extends BaseResponse {
  Data: ApiNullVO;
}

/**
 * 提现接口，兑换虚拟现金为个人钱包真实现金
 * @param params
 * @returns
 */
export async function withDraw(request: withDrawRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/withdraw');
  return DsbcApi.fetch<withDrawResponse>(url, request, true, options);
}
